<template>
  <div class="index-container" :style="{ background: bgColor }">
    <div class="content">
      <div class="title">
        <Icon type="ios-home"></Icon>
      </div>
      <ul>
        <li class="index" @click="$router.push('/')" v-if="showIndex">首页</li>
        <slot></slot>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "IndexCategory",
  props: {
    bgColor: {
      type: String,
      default: "#fafafa"
    },
    showIndex: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="stylus" scoped>
.index-container
  height 45px
  line-height 45px
  .content
    width 1200px
    display flex
    margin 0 auto
    .title
      width 30px
      color #999
      text-align right
      font-size 18px
    ul
      display flex
      font-family '宋体'
      li
        padding 0 10px
        position relative
        &:before
          content '>'
          display inline-block
          position absolute
          left -2px
        &:first-child
          &:before
            content ''
      .index
        cursor pointer
</style>
